import React from 'react';

function BottomNav({ activeTab, onTabChange, totalUnread = 0 }) {
  return (
    <div className="bottom-nav">
      <button
        className={`nav-item ${activeTab === 'chats' ? 'active' : ''}`}
        onClick={() => onTabChange('chats')}
        style={{ position: 'relative' }}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
        <span className="nav-label">Chats</span>
        {totalUnread > 0 && (
          <span style={{
            position: 'absolute',
            top: 2,
            right: '50%',
            marginRight: -28,
            background: '#ef4444',
            color: '#fff',
            borderRadius: 10,
            padding: '1px 6px',
            fontSize: 10,
            fontWeight: 600,
            lineHeight: '16px',
            minWidth: 16,
            textAlign: 'center',
          }}>
            {totalUnread > 99 ? '99+' : totalUnread}
          </span>
        )}
      </button>
      
      <button
        className={`nav-item ${activeTab === 'account' ? 'active' : ''}`}
        onClick={() => onTabChange('account')}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        <span className="nav-label">Account</span>
      </button>
    </div>
  );
}

export default BottomNav;
